
import Vue from "vue"
export default Vue.extend({
    name:"PlanningChecklistComponent",
    props:["projectId"],
    data(){
        return {
            fields:[
                {key:"sn",label:"S/N"},
                {key:"name",label:"Name"},
                {key:"value",label:"Value"},
                {key:"actions",label:"Action"}
            ],
            
            valueTypes:[
                {text:"Boolean (Yes or No)",value:"BOOLEAN"},
                {text:"Range",value:"RANGE"},
                {text:"Percentage",value:"PERCENTAGE"},
                {text:"Status (Not Started, In Progress, Completed) ",value:"STATUS"},
            ],
            planningItem:{
                name:"",
                valueType:null,
                minValue:0,
                maxValue:0
            },
        }
    },
    computed:{
        project():any{
            return this.$store.getters['projectModule/getProjectById'](this.projectId)
        }
    },
    methods:{
        reInitPalnningItem(){
            this.planningItem = {
                name:"",
                valueType:null,
                minValue:0,
                maxValue:0
            }
        },

        editPreProcess(){

        },
        deletePreProcess(){

        },
        showPlanningModal(){
            this.reInitPalnningItem()
            this.$bvModal.show("planningModal")
        },
        doCreatePlanningItem(){
            let preProcess = {
                name:this.planningItem.name,
                valueType:this.planningItem.valueType,
                maxValue:this.planningItem.maxValue,
                minValue:this.planningItem.minValue
            }
            this.$store.commit("projectModule/addOrUpdatePlanningItemToProject",{sequenceId:this.project.sequenceId,id:this.project.id,preProcess})
            this.$bvModal.hide("planningModal")
            this.reInitPalnningItem()
        },
        onPlanningItemValueChanged(){
            this.$store.commit("projectModule/registerProjectChange",{sequenceId:this.project.sequenceId,projectId:this.project.id})
        }
    },
    mounted(){
        
    }
})
